<template>
  <!-- Monospace identifier (CIF / Session / GUID) with one-click copy.
       Shared by Tax History list + detail so IDs read and behave identically.
       Empty value renders a neutral em-dash and no copy affordance. -->
  <span class="copy-id" :class="{ 'copy-id--truncate': truncate }">
    <span class="copy-id__text" :title="hasValue ? String(value) : ''">{{ display }}</span>
    <v-btn
      v-if="hasValue"
      :icon="copied ? 'mdi-check' : 'mdi-content-copy'"
      :color="copied ? 'success' : undefined"
      variant="text"
      density="compact"
      size="x-small"
      class="copy-id__btn"
      :aria-label="copied ? 'คัดลอกแล้ว' : `คัดลอก${label ? ' ' + label : ''}`"
      @click.stop="copy"
    />
  </span>
</template>

<script>
export default {
  name: 'CopyId',
  props: {
    value: { type: [String, Number], default: '' },
    /** Accessible label suffix, e.g. "CIF" → aria-label "คัดลอก CIF". */
    label: { type: String, default: '' },
    /** Constrain width + ellipsis — use inside table cells. */
    truncate: { type: Boolean, default: false },
  },
  data() {
    return { copied: false };
  },
  computed: {
    hasValue() {
      return this.value !== null && this.value !== undefined && String(this.value).length > 0;
    },
    display() {
      return this.hasValue ? String(this.value) : '—';
    },
  },
  methods: {
    async copy() {
      if (!this.hasValue) return;
      try {
        await navigator.clipboard.writeText(String(this.value));
        this.copied = true;
        setTimeout(() => { this.copied = false; }, 1500);
      } catch {
        /* clipboard unavailable (insecure context / denied) — silently no-op */
      }
    },
  },
};
</script>

<style scoped>
.copy-id {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  min-width: 0;
  max-width: 100%;
}
.copy-id__text {
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace;
  font-size: 0.8125rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.copy-id--truncate .copy-id__text {
  max-width: 22ch;
}
.copy-id__btn {
  flex: 0 0 auto;
  opacity: 0.55;
  transition: opacity 0.15s ease;
}
.copy-id:hover .copy-id__btn,
.copy-id__btn:focus-visible {
  opacity: 1;
}
@media (prefers-reduced-motion: reduce) {
  .copy-id__btn { transition: none; }
}
</style>
